export default __webpack_public_path__ + "static/media/curbside_dsg.6bebc77b.svg";